import { useContext } from "react";
import { ModalSettingContext } from "../../index";
import { InputWhite } from "@UI/New/InputWhite";
import s from './index.module.css';

export const LinkToMeeting = () => {
    const { state, setFieldInState } = useContext(ModalSettingContext);

    return (
        <InputWhite 
            value={state.link_to_meeting}
            placeholder='Вставьте ссылку на встречу'
            onChange={value => setFieldInState({field: 'link_to_meeting', value})}
            className={s.input}
        />
    )
}